<template>
  <div>
    <v-card class="px-4 mt-6" flat>
      <v-layout wrap>
        <v-flex xs12>
          <v-btn @click="goBackToMainForm" x-small outlined class="mt-2 mb-3 primary white--text">
            <v-icon x-small class="mr-2">mdi-arrow-left</v-icon>{{ $t('1') }}
          </v-btn>
        </v-flex>
      </v-layout>
      
      <div v-if="!listOfEducationsAndCertifications">
        <v-layout wrap>
          <v-flex xs12 mt-1>
            <v-layout wrap>
              <v-flex >
                <b style="font-size:1.4em">{{ $t('2') }}</b>
                <!-- <v-chip color="orange" class="white--text ml-1 mb-6" x-small><v-icon class="mr-1" x-small>mdi-shimmer</v-icon>{{ $t('2bis') }}</v-chip> -->
              </v-flex>
              <v-flex text-end pr-6 pt-1>
                <span @click="isShowingVideoDialog = true" style="cursor:hand">
                  <v-icon small style="padding-bottom: 2px">mdi-play-circle</v-icon>
                  <span class="ml-1 textAsLink">{{ $t('video0') }}</span>
                </span>
              </v-flex>
            </v-layout>
            <div><b>{{ $t('3') }}</b></div>
            <div><span v-html="$t('4')"/></div>
            <div class="mt-4"><b>{{ $t('6') }}</b></div>
            <div>
              <div>{{ $t('7') }}</div>
            </div>
          </v-flex>
          <v-flex xs12>
            <div v-if="errorWhileParsing" class="orange--text mt-2">
              <div>{{ $t('9') }}</div>
              <div v-if="errorWhileParsingErrorType === 'too_many_tokens'">
                {{ $t('10b') }}
              </div>
              <div v-else>
                {{ $t('10') }}
              </div>
            </div>
          </v-flex>
          <v-flex xs12 mt-4>
            <div class="text-end">
              <v-btn style="position: absolute; right: 27px; margin-top: 10px; z-index:0" @click="parse" :disabled="!listOfEducationsAndCertificationsQuillStr.trim() || isParsingPending" class="secondary mr-4">{{ $t('11') }}</v-btn>
            </div>
          </v-flex>
        </v-layout>
        <div class="mt-1 mb-6">
          <vue-editor ref="editor" v-model="listOfEducationsAndCertificationsQuillStr" :editorToolbar="editorToolbar" :editorOptions="editorOptions"></vue-editor>  
        </div>
      </div>

      <div v-if="listOfEducationsAndCertifications">
        <v-layout wrap>
          <v-flex xs12>
            <v-btn @click="listOfEducationsAndCertifications = null" x-small outlined class="mt-2 mb-3 primary white--text">
              <v-icon x-small class="mr-2">mdi-arrow-left</v-icon>{{ $t('a0') }}
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout wrap v-if="listOfEducationsAndCertifications.educations.length === 0 && listOfEducationsAndCertifications.certifications.length === 0">
          <v-flex xs12 text-center pt-12>
            <div><b>{{ $t('a') }}</b></div>
          </v-flex>
        </v-layout>
        <v-layout wrap v-else>
          <v-flex xs12 text-center mb-3 mt-3>
            <h2>{{ $t('b') }}</h2>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap>
              <v-flex>
                <div>
                  {{ $t('c') }}
                </div>
                <div>
                  {{ $t('d') }}
                </div>    
              </v-flex>
              <v-flex xs12 text-end mb-3>
                <v-btn @click="useExtractedListOfEducationsAndCertifications" small class="secondary">
                  {{ $t('e') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <div style="overflow-y: scroll; height: calc(90vh - 250px); position: relative;">
              <v-layout wrap>
                <v-flex xs12>
                  <v-divider class="primary"/>
                </v-flex>
                <v-flex xs12 v-for="(education, index) in listOfEducationsAndCertifications.educations" :key="index">
                  <v-layout wrap>
                    <v-flex xs3 class="leftCell" pl-1>
                      <b>{{ $t('f1') }} {{ index + 1 }}</b>
                    </v-flex>
                    <v-flex xs9>
                      <view-education-or-certification :educationOrCertification="education" />
                    </v-flex>
                    <v-flex xs12>
                      <v-divider class="primary"/>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-for="(certification, index) in listOfEducationsAndCertifications.certifications" :key="index">
                  <v-layout wrap>
                    <v-flex xs3 class="leftCell" pl-1>
                      <b>{{ $t('f2') }} {{ index + 1 }}</b>
                    </v-flex>
                    <v-flex xs9>
                      <view-education-or-certification :educationOrCertification="certification" />
                    </v-flex>
                    <v-flex xs12>
                      <v-divider class="primary"/>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </v-card>
    

    <v-dialog v-model="isParsingPending" width="40%" persistent content-class="vDialogWithoutShadow">
      <v-layout wrap mb-6>
        <v-flex xs12 text-center>
          <v-avatar :size="225" color="primary">
            <img :src="images.main" class="mb-1">
          </v-avatar>
        </v-flex>
      </v-layout>
      <v-card class="px-6 pb-4 pt-4 text-center primary white--text">
        <div><b>{{ $t('12') }}</b></div>
        <v-progress-linear indeterminate color="secondary" class="mt-3"></v-progress-linear>
        <div class="mt-2"><small>{{ $t('12bis') }}</small></div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isShowingVideoDialog" height="90%" width="80%">
      <v-card class="pa-2 text-center" v-if="isShowingVideoDialog">
        <h3 class="mb-2 mt-2">{{ $t('video1') }}</h3>
        <video
          controls
          loop
          autoplay
          width="100%"
          height="600px"
          src="https://firebasestorage.googleapis.com/v0/b/esnwebservices-prod.appspot.com/o/public%2FExtraction%20d'une%20liste%20de%20diplo%CC%82mes%20et%20de%20certifications.mov?alt=media&token=5801d2ed-025b-4309-a6b9-a62dcad00656"
        />
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import { VueEditor } from "vue2-editor";
import ViewEducationOrCertification from '@/components/profile/ViewEducationOrCertification'

const functionsUrlBase = {
  'localhost': 'http://localhost:5001/esnwebservices-dev/us-central1',
  'esnwebservices-dev.firebaseapp.com': 'https://europe-west1-esnwebservices-dev.cloudfunctions.net',
  'esnwebservices-prod.firebaseapp.com': 'https://europe-west1-esnwebservices-prod.cloudfunctions.net',
  'esnwebservices.com': 'https://europe-west1-esnwebservices-prod.cloudfunctions.net'
}[window.location.hostname]

export default {
  components: {
    VueEditor,
    ViewEducationOrCertification
  },
  props: {
    profile: Object,
    isFromToken: Boolean,
    isEducationNotCertification: Boolean
  },
  data: () => ({
    listOfEducationsAndCertificationsQuillStr: '',
    editorToolbar: [[{ list: "bullet" }]],
    editorOptions: {
      formats: ['list', 'indent'],
      modules: { keyboard: { bindings: { 'tab': { key: 9, handler: function() { return false; } } } } }
    },
    isParsingPending: false,
    errorWhileParsing: false,
    errorWhileParsingErrorType: null,
    images: {
      main: require('@/assets/app/images/Science_Outline.svg')
    },
    isShowingVideoDialog: false,
    listOfEducationsAndCertifications: null
  }),
  methods: {
    async parse() {
      this.errorWhileParsing = false
      this.errorWhileParsingErrorType = null
      this.isParsingPending = true
      let listOfEducationsAndCertifications;
      if (this.isFromToken) {
        const response = await axios.post(`${functionsUrlBase}/parseListOfEducationsAndCertificationsFromToken?dossierId=${this.$route.params.dossierId}&accessToken=${this.$route.query.accessToken}`, {
          listOfEducationsAndCertificationsQuillStr: this.listOfEducationsAndCertificationsQuillStr
        })
        if (response.data.success) {
          listOfEducationsAndCertifications = response.data.listOfEducationsAndCertifications
        } else {
          this.errorWhileParsing = true
          this.errorWhileParsingErrorType = response.data.errorType
          this.isParsingPending = false
          return;
        }
      } else {
        const response = (await this.$functions.httpsCallable('parseListOfEducationsAndCertifications')({
          listOfEducationsAndCertificationsQuillStr: this.listOfEducationsAndCertificationsQuillStr,
          dossierId: this.$route.params.dossierId
        }))
        if (response.data.success) {
          listOfEducationsAndCertifications = response.data.listOfEducationsAndCertifications
        } else {
          this.errorWhileParsing = true
          this.errorWhileParsingErrorType = response.data.errorType
          this.isParsingPending = false
          return;
        }
      }
      this.listOfEducationsAndCertifications = listOfEducationsAndCertifications;
      this.isParsingPending = false
    },
    goBackToMainForm() {
      this.$emit('goBackToMainForm', { idOfElementToScrollTo: 'view-educations', idOfElementToBlink: 'view-educations', noBlinking: true, additionalPixels: -50 })
    },
    useExtractedListOfEducationsAndCertifications() {
      this.profile.educations = this.listOfEducationsAndCertifications.educations
      this.profile.certifications = this.listOfEducationsAndCertifications.certifications
      this.$emit('goBackToMainForm', { idOfElementToScrollTo: 'view-educations', idOfElementToBlink: 'view-educations', additionalPixels: -50 })
    }
  },
  watch: {
    listOfEducationsAndCertificationsQuillStr: {
      handler(val) {
        if (val.includes('<li>')) {
          this.listOfEducationsAndCertificationsQuillStr = val.replace(/<li>/g, '<li class="ql-indent-0">')
        }
      }
    }
  }
}
</script>



<i18n>
{
  "fr": {
    "1": "Revenir au formulaire",
    "2": "Sélectionner une liste de diplômes et certifications",
    "2bis": "Beta",
    "3": "Copiez-collez tous les diplômes et certifications",
    "4": "<span>Copiez dans le CV original <b>tout le texte</b> lié aux diplômes et aux certifications, puis collez-le ci-dessous.</span>",
    "6": "Puis cliquez sur \"Extraire\"",
    "7": "Notre algorithme va identifier une liste de diplômes et de certifications à partir de ce texte.",
    "9": "Erreur lors de l'extraction des diplômes et certifications.",
    "10": "Sincèrement désolé. Nous améliorons la fonctionnalité après chaque erreur comme celle-ci.",
    "10b": "Le texte sélectionné est trop long.",
    "11": "Extraire",
    "12": "Analyse en cours des diplômes et certifications...",
    "12bis": "Cela peut prendre un peu de temps.",
    "video0": "Voir un exemple",
    "video1": "Comment sélectionner une liste de diplômes et certifications d'un seul coup",

    "a0": "Retour à la sélection de texte",
    "a": "Aucun diplôme ou certification n'a pu être extrait.",
    "b": "Liste des diplômes et certifications extraits",
    "c": "Remplacer les actuels diplômes et certifications du formulaire par cette liste ?",
    "d": "Vous pourrez les éditer juste après.",
    "e": "Utiliser cette liste de diplômes et certifications",
    "f1": "Diplôme",
    "f2": "Certification"
  },
  "en": {
    "1": "Back to the form",
    "2": "Extract a list of diplomas and certifications at once",
    "2bis": "Beta",
    "3": "Copy-paste all the diplomas and certifications",
    "4": "<span>Copy in the original CV <b>all the text</b> related to the diplomas and certifications, then paste it below.</span>",
    "6": "Then click on \"Extract\"",
    "7": "Our algorithm will identify a list of diplomas and certifications from this text.",
    "9": "Error while extracting the diplomas and certifications.",
    "10": "Sorry about that. We improve this feature after each error like this one.",
    "10b": "The selected text is too long.",
    "11": "Extract",
    "12": "Analyzing the diplomas and certifications...",
    "12bis": "It may take a bit of time.",
    "video0": "See an example",
    "video1": "How to extract a list of diplomas and certifications at once",


    "a0": "Back to text selection",
    "a": "No diploma or certification have been extracted.",
    "b": "List of extracted diplomas and certifications",
    "c": "Replace the existing diplomas and certifications of the form with this list ?",
    "d": "You'll be able to edit them right after.",
    "e": "Use this list of diplomas and certifications",
    "f1": "Diploma",
    "f2": "Certification"
  }
}
</i18n>